import Cookies from 'universal-cookie'
import useGeneralStore from '../../store/general';
import { usePushNotifications } from '../../common/pushNotification';
import { MoonLoader } from 'react-spinners';
import drop_icon from './drop_icon.svg'
import "./DropZone.scss"
import { useState } from 'react';

const DropZone = ({ setSave, accept = false }) => {
    const cookies = new Cookies()
    const token = cookies.get('auth')
    const [isLoad, setLoad] = useState(false)
    const selectedSpace = useGeneralStore((state) => state.selectedSpace);
    const { addErrorPush } = usePushNotifications();

    const fetchPostImg = (file) => {
        setLoad(true)
        const fd = new FormData()
        fd.append('file', file)
        const url = `https://file.ecomru.ru:4453/api/v1/file/upload`

        const requestHeaders = {
            'Accept': 'application/json',
            'Cache-control': 'no-cache',
            'Authorization': `Bearer ${token}`,
            'Space': selectedSpace?.value
        }

        fetch(url, { body: fd, method: 'POST', headers: requestHeaders })
            .then(async (res) => {
                const data = await res.json();
                if (!res.ok) {
                    const errorMessage = data.detail || res.msg;
                    addErrorPush(`Ошибка загрузки файла. Обратитесь к разработчикам`);
                    throw new Error(`${res.status} ${errorMessage}`);
                }
                return data;
            })
            .then(json => {
                if (json?.url) {
                    setSave(json.url)
                }
            })
            .catch(err => {
                console.error(err)
            })
            .finally(() => setLoad(false))
    }

    const handleFileInput = (e) => {
        if (e.target.files.length === 0) {
            e.preventDefault()
            return
        }
        if (e.target.files[0]) {
            fetchPostImg(e.target.files[0])
        }
    }

    const acceptObj = accept ? accept : null

    return (
        <div className='drop-zone'>
            {
                isLoad
                    ?
                    <MoonLoader
                        size={40}
                    />
                    :
                    <>
                        <img src={drop_icon} alt='icon' />
                        <p>Перетащите файлы сюда или нажмите, чтобы <span>загрузить.</span></p>
                        <input
                            onChange={(e) => handleFileInput(e)}
                            className='input-file'
                            type='file'
                            {...acceptObj}
                        />
                    </>
            }
        </div>
    )
}

export { DropZone }